module.exports = __webpack_public_path__ + "img/main_05_product_img_01.1fd6a11b.png";